/* eslint-disable react/jsx-pascal-case */
/* eslint-disable eqeqeq */
import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import "./BinTransferMain.css";
import BinTransfer_Breadcrumbs from "./BinTransfer_BreadCrumbs";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { fExecuteAPI } from "../../Server/Apis";
import {
  fcovertToNumber,
  Get_ToggleDropDown_binsearch_Load,
} from "../../Utility/Utilitys";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import {
  CmpTextField,
  CmpTextFieldEnter,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import { CmpSelectBox } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BinTrnasferDetailCard } from "./BinTrnasferDetailCard";
import { MultiCardFlag } from "./BinAction";
import GCMultipleCard from "./component/GCMultipleCard";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
export default function BinTransferDetail() {
  const params = useParams();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const BintrasferDetailFocusOnLoad = useRef(null);
  var userId = params.id;
  var vOpenBinType = userId === "Out" ? "From Open" : "To Open";

  const vRdxReasonWmbin = useSelector((state) => state.SliceBin.value.wmBin);
  const vRdxBinTransferForm = useSelector(
    (state) => state.SliceBinTransfer.value.BintransferHead
  );

  // eslint-disable-next-line no-unused-vars
  const [sLoading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });
  const [sBinStock, setBinStock] = useState(0);
  const [binTransferObj, setBinTransferObj] = useState({
    cardId: "",
    binNo: "",
    binName: "",
    itmCd: "",
    srNo: "0",
    itmName: "",
    qty: "",
    unit: "",
    baseQty: 0,
    stock: "0",
    packQty: 0,
  });
  let vErrorInit = {
    cardId: "",
    binNo: "",
    binName: "",
    itmCd: "",
    srNo: "",
    itmName: "",
    qty: "",
    unit: "",
    baseQty: "",
    stock: "",
    packQty: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    cardId: "",
    binNo: "",
    binName: "",
    itmCd: "",
    srNo: "",
    itmName: "",
    qty: "",
    unit: "",
    baseQty: "",
    stock: "",
    packQty: "",
  });

  const [sUnitData, setUnitDataArr] = useState([]);
  const [sBinTransferLineItemsGridrowData, setBinTransferLineItemsGridrowData] =
    useState([]);

  const [
    BinTransferLineItemsGridColumnsData,
    setBinTransferLineItemsGridColumnsData,
  ] = useState([
    {
      field: "SrNo",
      headerName: "Sr No",
      width: 50,
    },
    {
      field: "VocTyp",
      headerName: "Voc Type",
      width: 50,
      hide: true,
    },
    {
      field: "VocNo",
      headerName: "Voc No",
      width: 50,
      hide: true,
    },
    {
      field: "BinCd",
      headerName: "Bin Code",
      width: 50,
      hide: true,
    },
    {
      field: "BinName",
      headerName: "Bin",
      width: 130,
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 50,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 280,
    },
    {
      field: "Qty",
      headerName: "Qty ",
      width: 50,
    },
    {
      field: "UNit",
      headerName: "Unit Code",
      width: 90,
      hide: true,
    },
    {
      field: "UnitName",
      headerName: "Unit",
      width: 90,
    },
    {
      field: "BaseQty",
      headerName: "Base Qty ",
      width: 80,
    },
    {
      field: "ROW_NDX",
      headerName: "Row Ndx",
      width: 50,
      hide: true,
    },
  ]);

  const BinTransferLineItemsGridRowData = sBinTransferLineItemsGridrowData?.map(
    (obj, i) => ({ ...obj, id: i + 1 })
  );

  //MultipleCard start
  const [sMultipleCardModal, setMultipleCardModal] = useState(false);
  const [sMultipleCardData, setMultipleCardData] = useState([]);

  const fOpenMultipleCardModal = () => {
    setMultipleCardModal(true);
  };
  const fMultipleCard = async (e) => {
    // const { HeadObject } = InboundGrn();
    // await GetMultipleCard(
    //   HeadObject.A_RefDocNo,
    //   HeadObject.A_RefDocTyp,
    //   setMultipleCardData

    // );
    fOpenMultipleCardModal();
  };
  const fCloseMultipleCardModal = (e) => {
    setMultipleCardModal(false);
  };
  //MultiCard end

  const GetMultiBarcodeDetail = async (xBarcode, xBinCd) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_BinCd: xBinCd,
      v_Loc: vRdxBinTransferForm.LocCode,
      v_VocTyp: vRdxBinTransferForm.DocType,
      v_VocNo: vRdxBinTransferForm.DocNo,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_MULTI_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length == 0) {
        setBinTransferObj((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          // CardId: "",
          Unit: "",
        }));
        fAlertToast("WARNING", "Wrong Barcode Id");
      } else if (vBarcodeDetail.ResultSet.length == 1) {
        GetDetailFromCardID(vBarcodeDetail?.ResultSet[0]?.CARDID, false);
      } else if (vBarcodeDetail.ResultSet.length > 1) {
        setMultipleCardData(vBarcodeDetail.ResultSet);
        fMultipleCard();
      }
    } else {
      fAlertToast(
        "FAILED",
        vBarcodeDetail.response.data.message ||
          vBarcodeDetail.Message ||
          "Error in Loading MultiBarcode "
      );
      return;
    }
  };

  const fCardIdKey = (e) => {
    if (e.key === "Enter") {
      if (binTransferObj.cardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      }
      if (binTransferObj.binName == "" || binTransferObj.binNo == "") {
        fAlertToast("FAILED", "BinCode is empty");
        setTimeout(() => {
          document.getElementById("BinName")?.focus();
        }, 100);
      } else if (MultiCardFlag()) {
        GetMultiBarcodeDetail(binTransferObj.cardId, binTransferObj.binNo);
      } else if (vRdxBinTransferForm.Type === vOpenBinType) {
        GetCartBarcodeDetail(binTransferObj.cardId);
      } else {
        GetDetailFromCardID(binTransferObj.cardId);
      }
    } else if (e.key === "Backspace") {
      setBinTransferObj((obj) => ({
        ...obj,
        itmName: "",
        itmCd: "",
        unit: "",
      }));
      setUnitDataArr([]);
    } else if (e.key === "Delete") {
      if (binTransferObj.cardId == "") {
        setBinTransferObj((obj) => ({
          ...obj,
          itmName: "",
          itmCd: "",
        }));
      }
    }
  };

  const fBinNameKey = async (e) => {
    if (e.key === "Enter") {
      const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
        binTransferObj.binName,
        "Any",
        "Y",
        vRdxBinTransferForm.LocCode
      );

      if (vReasonWmBin?.length > 0) {
        setBinTransferObj((obj) => ({
          ...obj,
          binNo: vReasonWmBin[0].UId,
          binName: vReasonWmBin[0].Name1,
        }));
        document.getElementById("cardId")?.focus();
      } else {
        fAlertToast("FAILED", "Wrong BinName");
      }
    }
    if (e.key === "Backspace") {
      setBinTransferObj((obj) => ({
        ...obj,
        binNo: "",
        stock: 0,
      }));
    } else if (e.key === "Delete") {
      if (binTransferObj.binName == "") {
        setBinTransferObj((obj) => ({
          ...obj,
          binNo: "",
          stock: 0,
        }));
      }
    }
  };

  const fQtyKey = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      if (binTransferObj.qty !== "") {
        fSave();
      }
    }
  };
  const fBinTransferOut = (e) => {
    if (e.target.name === "cardId") {
      if (parseInt(e.target.value) >= 0) {
        setBinTransferObj((obj) => ({
          ...obj,
          [e.target.name]: e.target.value,
        }));
      } else if (e.target.value === "") {
        setBinTransferObj((obj) => ({
          ...obj,
          [e.target.name]: "",
        }));
      }
    } else {
      setBinTransferObj((obj) => ({
        ...obj,
        [e.target.name]: e.target.value,
      }));
    }

    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < binTransferObj.cardId.toString().length &&
      vMediaQuery &&
      e.target.name === "cardId"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "") {
        fCardIdKey(vBackspaceObj);
      }
    }
    if (
      e.target.value.length < binTransferObj.binName.toString().length &&
      vMediaQuery &&
      e.target.name === "binName"
    ) {
      if (e.target.value !== "") {
        fBinNameKey(vBackspaceObj);
      }
    }
  };

  const fBinQty = (e) => {
    if (e.target.value >= 0) {
      setBinTransferObj((obj) => ({
        ...obj,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const fUnitSelect = (e) => {
    var vUnit = sUnitData.find((obj) => {
      return obj.Unit == e.target.value;
    });

    setBinTransferObj((obj) => ({
      ...obj,
      unit: vUnit.Unit,
      packQty: vUnit.PackQty,
    }));
    // setPackQty(vUnit.PackQty);
  };

  const fGridRowData = (e) => {
    setBinTransferObj((obj) => ({
      ...obj,
      cardId: e.row.CardId,
      binNo: e.row.BinCd,
      binName: e.row.BinName,
      itmCd: e.row.ItmCd,
      srNo: e.row.SrNo,
      itmName: e.row.ItmName,
      qty: e.row.Qty,
      unit: e.row.UNit,
      // baseQty:e.row.B_BaseQty,
    }));
  };

  //Api call
  const GetDetailFromCardID = async (xCard = binTransferObj.cardId) => {
    let vCardIDObj = {
      v_CardID: xCard,
    };
    const cardIdInfo = await fExecuteAPI("BIN_TRANSFER_CARD_ID", vCardIDObj);
    if (cardIdInfo.Type?.toUpperCase() === "SUCCESS") {
      if (cardIdInfo?.ResultSet?.length > 0) {
        setBinTransferObj((obj) => ({
          ...obj,
          itmCd: cardIdInfo.ResultSet[0].ItmCd,
          itmName: cardIdInfo.ResultSet[0].Name2,
        }));
        if (vRdxBinTransferForm.Type === vOpenBinType) {
          document.getElementById("qty")?.focus();
        } else {
          document.getElementById("qty")?.focus();
        }
      } else {
        setBinTransferObj((obj) => ({
          ...obj,
          itmName: "",
          itmCd: "",
          // cardId: "",
          stock: 0,
          unit: "",
        }));
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else if (cardIdInfo.Type?.toUpperCase() === "FAILED") {
      // setBinTransferObj((obj) => ({ ...obj, cardId: "" }));
      fAlertToast("FAILED", cardIdInfo.Message);
    }
  };
  const GetCartBarcodeDetail = async (xBarcode = binTransferObj.cardId) => {
    const CartBarcodeDetailObj = {
      v_Barcode: binTransferObj.cardId || xBarcode,
      v_Loc: vRdxBinTransferForm.LocCode,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_BARCODE_DETAILS",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail?.ResultSet?.length > 0) {
        setBinTransferObj((obj) => ({
          ...obj,
          itmCd: CartBarcodeDetail.ResultSet[0].ItmCd,
          itmName: CartBarcodeDetail.ResultSet[0].Name2,
        }));
        setBinTransferObj((obj) => ({
          ...obj,
          cardId: CartBarcodeDetail.ResultSet[0].CardID,
        }));
        if (vRdxBinTransferForm.Type === vOpenBinType) {
          document.getElementById("qty")?.focus();
        } else {
          document.getElementById("qty")?.focus();
        }
      } else {
        setBinTransferObj((obj) => ({
          ...obj,
          itmName: "",
          itmCd: "",
          // cardId: "",
          stock: 0,
          unit: "",
        }));
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else if (CartBarcodeDetail?.Type?.toUpperCase() === "FAILED") {
      // setBinTransferObj((obj) => ({ ...obj, cardId: "" }));
      fAlertToast("FAILED", CartBarcodeDetail.Message);
    }
  };

  const GetItemCdDetail = async () => {
    const itemCdInfo = await fExecuteAPI(
      "ITEM_UNIT_GETROW",
      binTransferObj.itmCd
    );
    if (itemCdInfo.Type == "SUCCESS") {
      if (itemCdInfo?.ResultSet?.length > 0) {
        setUnitDataArr(itemCdInfo.ResultSet);
        setBinTransferObj((obj) => ({
          ...obj,
          unit: itemCdInfo.ResultSet[0].Unit,
          packQty: itemCdInfo.ResultSet[0].PackQty,
        }));

        // setPackQty(itemCdInfo.ResultSet[0].PackQty);
      }
    } else if (itemCdInfo.Type == "FAILED") {
      fAlertToast("FAILED", itemCdInfo.Message);
    }
  };

  const GetBinTRansferUpdate = async () => {
    let vBinTRansferUpdateObj = {
      v_VocTyp: vRdxBinTransferForm.DocType,
      v_VocNo: vRdxBinTransferForm.DocNo,
      v_SrNo: binTransferObj.srNo,
      v_BinCd: binTransferObj.binNo,
      v_CardID: binTransferObj.cardId,
      v_ItmCd: binTransferObj.itmCd,
      v_Qty: binTransferObj.qty,
      v_Unit: binTransferObj.unit,
      v_BaseQty: binTransferObj.baseQty,
      v_BinName: binTransferObj.binName,
      v_LocCode: vRdxBinTransferForm.LocCode,
      v_TrnTyp: userId,
    };

    const vBinTRansferUpdate = await fExecuteAPI(
      "GET_API_BIN_TRANSFER_DETAIL_UPDATE",
      vBinTRansferUpdateObj
    );

    if (vBinTRansferUpdate?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully submitted");
      fOnPresNew();
    }
    if (vBinTRansferUpdate.Type?.toUpperCase() === "FAILED") {
      // setFailedMessage(vBinTRansferUpdate.Message)
      fAlertToast("FAILED", vBinTRansferUpdate.Message);
    }
  };

  const GetBinStock = async () => {
    let vBinStockTransOutObj = {
      v_DocTyp: vRdxBinTransferForm.DocType,
      v_DocNo: vRdxBinTransferForm.DocNo,
      v_SrNo: binTransferObj.srNo,
      v_Loc: vRdxBinTransferForm.LocCode,
      v_CardID: binTransferObj.cardId,
      v_BinCd: binTransferObj.binNo,
      v_Qty: fcovertToNumber(binTransferObj.qty),
    };

    if (
      binTransferObj.itmCd !== "" &&
      binTransferObj.cardId !== "" &&
      binTransferObj.binNo !== ""
    ) {
      const vBinStockTransOut = await fExecuteAPI(
        "GET_API_BIN_STOCK_TRANSOUT",
        vBinStockTransOutObj
      );

      if (vBinStockTransOut?.ResultSet?.length > 0) {
        setBinStock(vBinStockTransOut.ResultSet[0].StkQty);
      } else if (vBinStockTransOut.Type == "FAILED") {
        fAlertToast("FAILED", vBinStockTransOut.Message);
      }
    } else if (
      binTransferObj.itmCd === "" ||
      binTransferObj.cardId === "" ||
      binTransferObj.binNo !== ""
    ) {
      setBinStock(0);
    }
  };

  const GetBinTransferDelete = async () => {
    let vBinTransferDeleteObj = {
      v_VocTyp: vRdxBinTransferForm.DocType,
      v_VocNo: vRdxBinTransferForm.DocNo,
      v_SrNo: binTransferObj.srNo,
      v_TrnTyp: userId,
    };

    const vBinTransferDelete = await fExecuteAPI(
      "GET_API_BIN_TRANSFER_DELETE",
      vBinTransferDeleteObj
    );
    if (vBinTransferDelete?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully deleted");
      fOnPresNew();
    } else if (vBinTransferDelete?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vBinTransferDelete.Message);
    }
    fOnPresNew();
  };

  const GetBinTransferLineItems = async () => {
    let vBinTransferLineItemsObj = {
      v_VocTyp: vRdxBinTransferForm.DocType,
      v_VocNo: vRdxBinTransferForm.DocNo,
      v_TrnTyp: userId,
    };

    const vBinTransferLineItems = await fExecuteAPI(
      "GET_API_BIN_TRANSFER_LINEITEM",
      vBinTransferLineItemsObj
    );
    if (vBinTransferLineItems?.Type?.toUpperCase() === "SUCCESS") {
      if (vBinTransferLineItems?.ResultSet?.length > 0) {
        setBinTransferLineItemsGridrowData(vBinTransferLineItems.ResultSet);
      } else {
        setBinTransferLineItemsGridrowData([]);
      }
    } else if (vBinTransferLineItems?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vBinTransferLineItems.Message);
    }
  };

  const setValidation = () => {
    setErrorMsg({
      cardId: "",
      binNo: "",
      binName: "",
      itmCd: "",
      srNo: "",
      itmName: "",
      qty: "",
      unit: "",
      baseQty: "",
      stock: "",
      packQty: "",
    });
    let iRes = true;
    if (binTransferObj.cardId === "") {
      setErrorMsg((obj) => ({ ...obj, cardId: "cardId is Empty" }));
      iRes = false;
    }
    if (binTransferObj.binNo === "") {
      setErrorMsg((obj) => ({ ...obj, binNo: "binNo is Empty" }));
      iRes = false;
    }
    if (binTransferObj.binName === "") {
      setErrorMsg((obj) => ({ ...obj, binName: "binName is Empty" }));
      iRes = false;
    }
    if (binTransferObj.itmCd === "") {
      setErrorMsg((obj) => ({ ...obj, itmCd: "itmCd is Empty" }));
    }
    if (binTransferObj.srNo === "") {
      setErrorMsg((obj) => ({ ...obj, srNo: "srNo is Empty" }));
      iRes = false;
    }
    if (binTransferObj.itmName === "") {
      setErrorMsg((obj) => ({ ...obj, itmName: "itmName is Empty" }));
      iRes = false;
    }
    if (binTransferObj.qty === "") {
      setErrorMsg((obj) => ({ ...obj, qty: "Quantity is Empty" }));
      iRes = false;
    } else if (binTransferObj.qty <= 0) {
      setErrorMsg((obj) => ({ ...obj, qty: "Quantity shouldn't be zero." }));
      iRes = false;
    } else if (binTransferObj.qty > binTransferObj.stock && userId === "Out") {
      setErrorMsg((obj) => ({
        ...obj,
        qty: "Quantity shouldn't be greater then stock.",
      }));
      iRes = false;
    }
    if (binTransferObj.unit === "") {
      setErrorMsg((obj) => ({ ...obj, unit: "unit is Empty" }));
      iRes = false;
    }
    if (binTransferObj.baseQty === "") {
      setErrorMsg((obj) => ({ ...obj, baseQty: "baseQty is Empty" }));
      iRes = false;
    }
    if (binTransferObj.stock === "") {
      setErrorMsg((obj) => ({ ...obj, stock: "stock is Empty" }));
      iRes = false;
    } else if (binTransferObj.stock === 0 && userId == "Out") {
      setErrorMsg((obj) => ({ ...obj, stock: "stock is zero." }));
      iRes = false;
    }
    if (binTransferObj.packQty === "") {
      setErrorMsg((obj) => ({ ...obj, packQty: "packQty is Empty" }));
      iRes = false;
    }

    return iRes;
  };
  let timeout = null;
  //onClick
  const fSave = () => {
    clearTimeout(timeout);

    timeout = setTimeout(async () => {
      setErrorMsg(vErrorInit);
      if (userId == "Out" || userId == "In") {
        if (setValidation()) {
          GetBinTRansferUpdate();
          // fOnPresNew();
        }
      }
    }, 800);
  };

  const fOnPresNew = () => {
    setUnitDataArr([]); //unit arr
    if (vRdxBinTransferForm.Type !== vOpenBinType) {
      setBinTransferObj((obj) => ({
        ...obj,
        cardId: "",
        binNo: "",
        binName: "",
        itmCd: "",
        srNo: "0",
        itmName: "",
        qty: "",
        unit: "",
        baseQty: "",
        stock: 0,
        packQty: 0,
      }));
    } else {
      setBinTransferObj((obj) => ({
        ...obj,
        cardId: "",
        itmCd: "",
        srNo: "0",
        itmName: "",
        qty: "",
        unit: "",
        baseQty: "",
        stock: 0,
        packQty: 0,
      }));
    }
    GetBinTransferLineItems(); //grid
    setErrorMsg(vErrorInit);
    BintrasferDetailFocusOnLoad.current?.focus();
  };
  const fOnDelete = () => {
    if (window.confirm("Are you sure you want to Delete?") == true) {
      GetBinTransferDelete();
      GetBinTransferLineItems(); //grid
    }
  };

  useEffect(() => {
    if (binTransferObj.itmCd !== "") {
      GetItemCdDetail();
    }
  }, [binTransferObj.itmCd]);

  useEffect(() => {
    if (
      binTransferObj.itmCd !== "" &&
      binTransferObj.cardId !== "" &&
      binTransferObj.binNo !== ""
    ) {
      GetBinStock();
    } else if (
      binTransferObj.itmCd === "" ||
      binTransferObj.cardId === "" ||
      binTransferObj.binNo === ""
    ) {
      setBinStock(0);
    }
  }, [binTransferObj.itmCd, binTransferObj.cardId, binTransferObj.binNo]);

  useEffect(() => {
    if (
      binTransferObj.itmCd !== "" &&
      binTransferObj.cardId !== "" &&
      binTransferObj.binNo !== ""
    ) {
      let vStockCal =
        binTransferObj.packQty == 0 ? 0 : sBinStock / binTransferObj.packQty;
      setBinTransferObj((obj) => ({
        ...obj,
        stock: fcovertToNumber(vStockCal),
      }));
    } else {
      setBinStock(0);
      setBinTransferObj((obj) => ({ ...obj, stock: 0 }));
    }
  }, [binTransferObj.packQty, sBinStock]);

  useEffect(() => {
    setBinTransferObj((obj) => ({
      ...obj,
      baseQty: fcovertToNumber(binTransferObj.qty * binTransferObj.packQty),
    }));
  }, [binTransferObj.qty, binTransferObj.packQty]);

  useEffect(() => {
    GetBinTransferLineItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vRdxBinTransferForm]);

  useEffect(() => {
    if (vRdxBinTransferForm.Type === vOpenBinType) {
      setBinTransferObj((obj) => ({
        ...obj,
        binNo: vRdxReasonWmbin[0]?.UId,
        binName: vRdxReasonWmbin[0]?.Name1,
      }));
    }
  }, [vRdxBinTransferForm, vOpenBinType, vRdxReasonWmbin]);

  const [sOpenBinTransferOutModel, setOpenBinTransferOutModel] =
    useState(false);
  const fCloseBinTransferOutModel = () => {
    setOpenBinTransferOutModel(false);
  };
  const fOpenBinTransferOutModel = () => {
    setOpenBinTransferOutModel(true);
  };
  useEffect(() => {
    BintrasferDetailFocusOnLoad.current?.focus();
  }, []);

  useEffect(() => {
    GetGitterColumns(
      setBinTransferLineItemsGridColumnsData,
      "BIN_TRANSFER_DETAIL",
      BinTransferLineItemsGridColumnsData
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div>
        <BinTransfer_Breadcrumbs />
      </div>
      <div className="BinTransferContainer">
        <div className="BinTransferUnderContainer BinTransferOut">
          <div className="BinTransferBtnContainer">
            <Box sx={{ flexGrow: 1 }} className="xs-hide-label-out">
              <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
                <Grid item xs={24} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 10, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2} className="xs-hide-label-out">
                      <label className="title-f ">Doc.Type</label>
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"Doc.Type"}
                        xVariant={"standard"}
                        xValue={vRdxBinTransferForm.DocType}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"Doc.Type"}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"Doc.Name"}
                        xVariant={"standard"}
                        xValue={vRdxBinTransferForm.DocTypName}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"Doc.NAme"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 2, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2} className="xs-hide-label-out">
                      <label className="title-f ">Doc.No</label>
                    </Grid>
                    <Grid item xs={10}>
                      <CmpTextField
                        xLabelText={"Doc.DocNo"}
                        xVariant={"standard"}
                        xValue={vRdxBinTransferForm.DocNo}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"Doc.DocNo"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 2, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2} className="xs-hide-label-out">
                      <label className="title-f ">Type</label>
                    </Grid>
                    <Grid item xs={10}>
                      <CmpTextField
                        xLabelText={"Type"}
                        xVariant={"standard"}
                        xValue={vRdxBinTransferForm.Type}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"Type"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 2, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2} className="xs-hide-label-out">
                      <label className="title-f ">Status</label>
                    </Grid>
                    <Grid item xs={10}>
                      <CmpTextField
                        xLabelText={"Status"}
                        xVariant={"standard"}
                        xValue={vRdxBinTransferForm.Status}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"Status"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </div>
          <div></div>
          <div className=" bintransfer-out-body">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"Sr.No"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.srNo}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={true}
                    xType={"number"}
                    xName={"srNo"}
                    xError={sErrorMsg.srNo === "" ? false : true}
                    xErrorMessage={sErrorMsg.srNo}
                  />
                </Grid>

                <Grid item xs={8}>
                  <CmpTextFieldEnter
                    xref={BintrasferDetailFocusOnLoad}
                    xLabelText={"Bin Name"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.binName}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xOnKeyUp={(e) => {
                      fBinNameKey(e);
                    }}
                    xReadOnly={
                      vRdxBinTransferForm.Type !== vOpenBinType ? false : true
                    }
                    xType={"text"}
                    xName={"binName"}
                    xError={sErrorMsg.binName === "" ? false : true}
                    xErrorMessage={sErrorMsg.binName}
                    xOnEnter={(e) => {
                      fBinNameKey(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"Bin No"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.binNo}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"binNo"}
                    xError={sErrorMsg.binNo === "" ? false : true}
                    xErrorMessage={sErrorMsg.binNo}
                  />
                </Grid>
                <Grid item xs={8}>
                  <CmpTextFieldEnter
                    xLabelText={"Card ID"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.cardId}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={false}
                    xType={"number"}
                    xName={"cardId"}
                    xOnKeyUp={(e) => {
                      fCardIdKey(e);
                    }}
                    xError={sErrorMsg.cardId === "" ? false : true}
                    xErrorMessage={sErrorMsg.cardId}
                    xOnEnter={(e) => {
                      fCardIdKey(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"Item Code"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.itmCd}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"itmCd"}
                    xError={sErrorMsg.itmCd === "" ? false : true}
                    xErrorMessage={sErrorMsg.itmCd}
                  />
                </Grid>
                <Grid item xs={8}>
                  <CmpTextField
                    xLabelText={"Item Name"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.itmName}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"itmName"}
                    xError={sErrorMsg.itmName === "" ? false : true}
                    xErrorMessage={sErrorMsg.itmName}
                  />
                </Grid>

                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"Qty"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.qty}
                    xOnChange={(event) => fBinQty(event)}
                    xReadOnly={false}
                    xType={"number"}
                    xName={"qty"}
                    xOnKeyUp={(e) => {
                      fQtyKey(e);
                    }}
                    xError={sErrorMsg.qty === "" ? false : true}
                    xErrorMessage={sErrorMsg.qty}
                  />
                </Grid>
                <Grid item xs={8}>
                  <CmpSelectBox
                    xLabelText="Unit"
                    xValue={binTransferObj.unit}
                    xOnChange={(event) => fUnitSelect(event)}
                    xName={"unit"}
                    xData={sUnitData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.unit === "" ? false : true}
                    xErrorMessage={sErrorMsg.unit}
                    xDisable={false}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"Base Qty"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.baseQty}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={true}
                    xType={"number"}
                    xName={"baseQty"}
                    xError={sErrorMsg.baseQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.baseQty}
                  />
                </Grid>
                <Grid item xs={8}>
                  <CmpTextField
                    xLabelText={"Stock"}
                    xVariant={"outlined"}
                    xValue={binTransferObj.stock}
                    xOnChange={(event) => fBinTransferOut(event)}
                    xReadOnly={true}
                    xType={"number"}
                    xName={"stock"}
                    xError={sErrorMsg.stock === "" ? false : true}
                    xErrorMessage={sErrorMsg.stock}
                  />
                </Grid>
              </Grid>
            </Box>

            <div className="BinTransferFooterBtnContainer bintransfer-out">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={1} columns={{ xs: 8, sm: 12, md: 12 }}>
                  <Grid item xs={4}>
                    <CmpButton
                      xbtnName="New"
                      xOnClick={fOnPresNew}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CmpButton
                      xbtnName="Save"
                      xOnClick={fSave}
                      xVariant="contained"
                      xDisabled={vRdxBinTransferForm?.Status === "POST"}
                      xSize="small"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CmpButton
                      xbtnName="Delete"
                      xOnClick={fOnDelete}
                      xVariant="contained"
                      xDisabled={vRdxBinTransferForm?.Status === "POST"}
                      xSize="small"
                    />
                  </Grid>

                  <Grid item xs={4} className="bintransfer-btn-grid-sm-show">
                    <CmpButton
                      xbtnName="Detail"
                      xOnClick={fOpenBinTransferOutModel}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                    />
                  </Grid>
                </Grid>
              </Box>
            </div>
            <div
            // className="bintransfer-btn-grid-sm-hide"
            >
              {/* <Box
                sx={{ height: vMediaQuery ? "70vh" : "30vh", width: "100%" }}
                className="bintransfer-out-grid"
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  getRowId={(row) => row.id}
                  rows={BinTransferLineItemsGridRowData}
                  columns={BinTransferLineItemsGridColumnsData}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  experimentalFeatures={{ newEditingApi: false }}
                  // onRowClick={() => navigate('/BinTrnasferForm')}
                  onRowClick={fGridRowData}
                  hideFooter={BinTransferLineItemsGridRowData.length < 100}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </Box> */}

              {BinTransferLineItemsGridRowData?.length > 0 && (
                <Box>
                  <Grid
                    container
                    spacing={{ xs: 0, md: 3 }}
                    columns={{ xs: 12, sm: 12, md: 8 }}
                  >
                    {BinTransferLineItemsGridRowData?.map((obj, index) => (
                      <Grid item xs={12} sm={12} md={4} key={index}>
                        <BinTrnasferDetailCard
                          SrNo={obj.SrNo}
                          BinName={obj.BinName}
                          ItemCode={obj.ItmCd}
                          ItemName={obj.ItmName}
                          Qty={obj.Qty}
                          UnitName={obj.UnitName}
                          BaseQty={obj.UnitName}
                          onClick={() => {
                            let e = {
                              row: obj,
                            };
                            fGridRowData(e);
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={sOpenBinTransferOutModel}
        onClose={fCloseBinTransferOutModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Grid"} onClose={fCloseBinTransferOutModel} />

          <div className="py-3">
            {/* <div className="d-flex justify-content-end">
              <CloseIcon onClick={fCloseBinTransferOutModel} />
            </div> */}

            {/* <Box
                sx={{ height: vMediaQuery ? "70vh" : "30vh", width: "100%" }}
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  getRowId={(row) => row.id}
                  rows={BinTransferLineItemsGridRowData}
                  columns={BinTransferLineItemsGridColumnsData}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  experimentalFeatures={{ newEditingApi: false }}
                  onRowClick={fGridRowData}
                  onRowDoubleClick={fCloseBinTransferOutModel}
                  hideFooter={BinTransferLineItemsGridRowData.length < 100}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </Box>  */}

            {BinTransferLineItemsGridRowData?.length > 0 && (
              <Box>
                <Grid
                  container
                  spacing={{ xs: 0, md: 3 }}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  {BinTransferLineItemsGridRowData?.map((obj, index) => (
                    <Grid item xs={12} sm={12} md={4} key={index}>
                      <BinTrnasferDetailCard
                        SrNo={obj.SrNo}
                        BinName={obj.BinName}
                        ItemCode={obj.ItmCd}
                        ItemName={obj.ItmName}
                        Qty={obj.Qty}
                        UnitName={obj.UnitName}
                        BaseQty={obj.UnitName}
                        onClick={() => {
                          let e = {
                            row: obj,
                          };
                          fGridRowData(e);
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </div>
        </Box>
      </Modal>

      <GCMultipleCard
        xOpen={sMultipleCardModal}
        fCloseDetailModal={fCloseMultipleCardModal}
        sMultipleCard={sMultipleCardData}
        xTitle={"Card Detail"}
        onClickMultipleCard={(obj) => {
          GetDetailFromCardID(obj.CARDID, false);
          fCloseMultipleCardModal();
        }}
      />
    </>
  );
}
